import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-data-display-dialog',
  templateUrl: './data-display-dialog.component.html',
  styleUrls: ['./data-display-dialog.component.scss']
})
export class DataDisplayDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<DataDisplayDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close();
  }

  get dataKeys() {
      return this.data ? Object.keys(this.data) : [];
  }
}
